import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {ButtonModule} from '@ucx/ui-cmp';
import { CommonModule } from '@angular/common';
import {
  SurveyStatementOfDeficienciesHistoryModalComponent
} from './survey-statement-of-deficiencies-history-modal.component';

@NgModule({
    declarations: [
      SurveyStatementOfDeficienciesHistoryModalComponent,
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        ButtonModule,
        CommonModule
    ],
    providers: [],
    exports: [
      SurveyStatementOfDeficienciesHistoryModalComponent
    ]
})

export class SurveyStatementOfDeficienciesHistoryModalModule {
}
